import {Component, OnInit, ViewChild} from '@angular/core';
import {
	KamonaLivelinessWidgetComponent
} from "../../../kamona-liveliness-widget/kamona-liveliness-widget.component";
import {
	CustomMetaMapButtonComponent
} from "../../../custom-meta-map-button/custom-meta-map-button.component";

@Component({
  selector: 'app-web-kamona-liveliness-widget',
  templateUrl: './web-kamona-liveliness-widget.component.html',
  styleUrls: ['./web-kamona-liveliness-widget.component.scss']
})
export class WebKamonaLivelinessWidgetComponent extends KamonaLivelinessWidgetComponent implements OnInit {
	@ViewChild("webMetaMapBtn") webMetaMapBtn: CustomMetaMapButtonComponent;
  constructor() {
	  super();
  }

  ngOnInit(): void {
	  this.initialize();
  }

	startMetamapVerification(){
		this.webMetaMapBtn?.handleOnClick();
	}

}
